import { ModalContextProvider } from 'utils/contexts/modal';
import {
  DynamicContentContextProvider,
  FormContextProvider,
  SnippetNamesContextProvider,
  FieldsContextProvider,
} from './contexts';
import { BuilderTakeover } from './components/BuilderTakeover';
import { DynamicContentModals } from './components/modals';
import { ContentType, InsertFn } from './types';

type DynamicContentBuilderProps = {
  onInsert: InsertFn;
  onClose: () => void;
  contentType?: ContentType;
};

export const DynamicContentBuilder = ({
  onInsert,
  onClose,
  contentType = ContentType.html,
}: DynamicContentBuilderProps) => (
  <DynamicContentContextProvider onInsert={onInsert} onClose={onClose} contentType={contentType}>
    <FormContextProvider>
      <SnippetNamesContextProvider>
        <FieldsContextProvider>
          <ModalContextProvider>
            <BuilderTakeover />
            <DynamicContentModals />
          </ModalContextProvider>
        </FieldsContextProvider>
      </SnippetNamesContextProvider>
    </FormContextProvider>
  </DynamicContentContextProvider>
);
